<template >
    <div class="common_template" v-show="dilgShow">
        <div class="dialog" >

            <div class="msk"></div>
            <div class="content_dialog">
                <i class="dialog_x" @click="closePop()"></i>
                <div class="dialog_banner lf" :class="{'dialog_banner_min':dilgType,'dialog_banner_register':!dilgType}"></div>
                <div class="dialog_form lf" v-show="!successText">
                        <div class="form_msk" v-show="loading">
                            <div class="form_msk_loading"></div>
                        </div>
                        <div class="fz18">{{title}}</div>
                        <div class="tag textAcenter">{{errorText}}</div>
                        <div class="ogrNationName">
                            <input type="text" id="ogrNationName" autocomplete="off" placeholder="请输入机构名称" v-model="org.name" required>
                            <!-- <div class="tag" :class="['top'+errorTop]" v-show="errorTop>0">
                                <div class="arrow">
                                    <em></em><span></span>
                                </div>
                                <span style="text-align: left">{{errorText}}</span>
                            </div> -->
                        </div>
                        <div><input type="text" id="contact" autocomplete="off" placeholder="请输入您的姓名" v-model="org.person" required></div>
                        <div><input type="text" id="iPhone" autocomplete="off" placeholder="请输入您的手机号码" v-model="org.phone" maxlength="11" required></div>
                        <div>
                            <input type="text" class="VerFicatCode" autocomplete="off" placeholder="请输入验证码" v-model="org.testCode" required>
                            <button type="button" class="get_VerFicatCode" v-bind:disabled="isDuringTime" @click="getTestcode()">{{codeText}}</button>
                        </div>

                        <div class="submitBtn" @click="submitBtn()">
                            提交
                        </div>
                </div>
                <!--成功显示-->
                <div class="dialog_success lf" v-show="successText">
                    <div class="dianzan"></div>
                    <div class="title_success">恭喜您申请成功</div>
                    <div class="title_info">{{successText}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    var count = 60,timerHandler = undefined;
    export default{
        mounted(){
            this.getTestcode();
        },
        data(){
            return {
                title:"",
                dilgType:"",
                dilgShow:false,
                org:{
                    name:"",
                    person:"",
                    phone:"",
                    testCode:""
                },
                codeText:"验证码",
                errorText:"",
                isDisabled:false,
                errorTop:0,
                nameIsempty:false,
                personIsempty:false,
                phoneIsempty:false,
                codeIsempty:false,
                errorStatus:false,
                isDuringTime:false,
                loading:false,
                successText:""
            }
        },
        methods:{
            openDialog:function(title, type){
                var  this_ = this;
                this_.dilgShow = true;
                this_.title = title;
                this_.dilgType = type;
                this_.org={
                    name:"",
                    person:"",
                    phone:"",
                    testCode:""
                };
                this_.isDuringTime = false;
                this_.codeText = "验证码";
                this_.successText = "";
                this_.errorText = "";
                this_.isDisabled = false;
                this_.errorTop = 0;
                this_.nameIsempty = false;
                this_.personIsempty = false;
                this_.phoneIsempty = false;
                this_.codeIsempty = false;
                this_.errorStatus = false;
                this_.loading = false;
            },
            closePop:function(){
                this.dilgShow = false;
            },
            submitBtn:function(){
                // 为了更加便捷的让用户申请，机构名称和联系人姓名两项都允许不填
                // if(!this.org.name){
                //     this.errorTop = 2;
                //     this.errorText = "请输入机构名称";
                //     return;
                // }
                // if(!this.org.person){
                //     this.errorTop = 50;
                //     this.errorText = "请输入机构联系人";
                //     return;
                // }
                if(!this.org.phone){
                    this.errorTop = 98;
                    this.errorText = "请输入手机号码";
                    return;
                }
                if(!this.org.testCode){
                    this.errorTop = 148;
                    this.errorText = "请输入验证码";
                    return;
                }
                var data = {
                    "visitorShopName": this.org.name,
                    "visitorName": this.org.person,
                    "visitorType":this.dilgType,
                    "visitorPhone": this.org.phone,
                    "code": this.org.testCode
                };
                this.loading = true;
                var this_ = this;
                $.ajax({
                    url:  this_.CONFIG.URL + '/api/admin/visitor/add',
                    type: "post",
                    data: JSON.stringify(data),
                    async: false,
                    contentType: "application/json;charset=UTF-8",
                    success: function (data) {
                         this_.$nextTick(()=>{
                            this_.loading = false;
                            if (data.status == '200') {
                                clearInterval(timerHandler);//停止计时器
                                this_.successText = data.message;
                                this_.codeText = "验证码";
                                this_.isDuringTime = false;
                            } else {
                                this_.errorText = data.message;
                                this_.errorTop = 158;
                            }
                         });
                    },
                    error:function(data){
                        this_.$nextTick(()=>{
                            this_.loading = false;
                            this_.errorText = "网络异常,请稍后再试";
                            this_.errorTop = 158;
                        });
                    }
                });
            },
            getTestcode:function(){
                var this_ = this;
                 if(!this.org.phone){
                     this.errorTop = 98;
                    this.errorText = "请输入手机号码";
                    return;
                }
                 if(!this.checkValidate()){
                    this.errorTop = 98;
                    this.errorText = "请输入正确的手机号";
                    return;
                 }
                  //设置button效果，开始计时
                if (this.isDuringTime) {
                    return;
                }
                    //向后台发送处理数据
                var data = {
                    "phone": this.org.phone
                }
                $.ajax({
                    url:  this_.CONFIG.URL + '/api/oa/sms/getAuthCode',
                    type: "get",
                    data: data,
                    success: function (data) {
                            this_.$nextTick(()=>{
                            if (data.status == '200') {
                                this_.codeText = count + "s后重发";
                                timerHandler = setInterval(function() {
                                    if (count <= 0) {
                                        clearInterval(timerHandler);
                                        count = 60;
                                        this_.codeText = "验证码";
                                        this_.isDuringTime = false;
                                        return;
                                    } else {
                                        count--;
                                        this_.codeText = count + "s后重发";
                                        this_.isDuringTime = true;
                                    }
                                }, 1000, 100)
                            } else {
                                 this_.errorText =data.message;
                                 this_.errorTop = 158;
                            }
                            });
                    },
                    error:function(data){
                        this_.$nextTick(()=>{
                            this_.errorText = "网络异常,请稍后再试";
                            this_.errorTop = 158;
                        });
                    }

                });

            },
            checkValidate:function(){
                if (!(/^1\d{10}$/.test(this.org.phone))) {
                    return false;
                }
                return true;
            }
        }
    }
</script>
<style  scoped lang="less">
/*以下是公用弹框等样式*/
.common_template .dialog{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 19931221;
}
.common_template .dialog .msk {
    width: 100%;
    height: 100%;
    background-color: #333333;
    opacity: 0.8;
}
.common_template .dialog .content_dialog {
    width: 50%;
    height: 352px;
    min-width: 500px;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 199312232;
    opacity: 1;
}
.common_template .dialog .dialog_x {
    width: 27px;
    height: 27px;
    position: absolute;
    border-radius: 50%;
    top: -40px;
    right: 0;
    background: url(/static/img/tankuang/x.png) no-repeat #CCD5E7;
    background-position: center center;
    background-size: 50% 50%;
    transition: all 0.5s;
    transform: rotate(0deg);
    cursor: pointer;
}
.common_template .dialog .dialog_x:hover {
    transform: rotate(360deg);
}
.common_template .dialog .dialog_banner {
    height: 100%;
    width: 40%;
}
.common_template .dialog .dialog_success {
    padding: 0 10%;
}
.common_template .dialog .dialog_form, .common_template .dialog .dialog_success {
    position: absolute;
    top: 0;
    left: 40%;
    bottom: 0;
    right: 0;
    text-align: center;
}
.common_template .dialog .form_msk {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #1f191f;
    opacity: 0.4;
    z-index: 1;
    display: none;
}
.common_template .dialog .form_msk_loading {
    width: 32px;
    height: 32px;
    background: url(/static/img/tankuang/loading.gif) no-repeat;
    background-size: contain;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
.common_template .dialog .dialog_form .fz18 {
    font-weight: bolder;
    color: #444;
    margin: 10px 0;;
}
.common_template .dialog .ogrNationName {
    position: relative;
}
.common_template .dialog .dialog_form input {
    border: 1px solid #B4B4B4;
    height: 35px;
    line-height: 35px;
    margin-bottom: 14px;
    width: 65%;
    outline: none;
    padding-left: 10px;
    max-width: 370px;
    text-align: left;
}
.common_template .dialog .tag {
    color:#FA7074;
    height: 24px;
    line-height: 24px;
    margin-bottom: 10px;
    /* padding: 0 10px;
    width: 150px;
    min-height: 32px;
    line-height: 28px;
    border: 1px solid #e6e6e6;
    position: absolute;
    background-color: #FFF;
    top: 2px;
    right: -110px;
    border-radius: 8px; */
}

/*.common_template .dialog .arrow * {
    display: block;
    border-width: 10px;
    position: absolute;
    border-style: solid dashed dashed dashed;
    font-size: 0;
    line-height: 0;
}
 .common_template .dialog .arrow {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 8px;
    left: -20px;
}
.common_template .dialog .arrow em {
    border-color: transparent #e6e6e6 transparent transparent;
}
.common_template .dialog .arrow span {
    color:#444;
    border-color: transparent #FFF transparent transparent;
    left: 2px;
}
.common_template .dialog .tag.top0 {
    top:0;
}
.common_template .dialog .tag.top2 {
    top:2px;
}
.common_template .dialog .tag.top50 {
    top:50px;
}
.common_template .dialog .tag.top98 {
    top:98px;
}
.common_template .dialog .tag.top148 {
    top:148px;
}
.common_template .dialog .tag.top158 {
    top:158px;
} */
.common_template .dialog .VerFicatCode {
    width: 43% !important;
    max-width: 245px !important;
}
.common_template .dialog .get_VerFicatCode {
    vertical-align: top;
    line-height: 35px;
    background: #FFABAD;
    border-radius: 4px;
    text-align: center;
    font-size: 12px;
    color: #fff;
    border: none;
    width: 21%;
    max-width: 120px;
    cursor: pointer;
}
.common_template .dialog .submitBtn {
    background-color: #FA7074;
    line-height: 35px;
    border-radius: 17px;
    font-size: 18px;
    width: 65%;
    max-width: 370px;
    color: #fff;
    border: none;
    box-shadow: 2px 0px 8px rgba(16, 16, 18, 0.21);
    margin:0 auto;
    cursor: pointer;
}
.common_template .dialog .dianzan {
    background: url(/static/img/tankuang/Capa1.png) no-repeat;
    width: 69px;
    height: 69px;
    margin: 42px auto 0;
    background-size: contain;
}
.common_template .dialog .title_success {
    color: #00A5F8;
    font-size: 24px;
    font-weight: bold;
    margin-top: 22px;
}
.common_template .dialog .title_info {
    color: #999999;
    font-size: 12px;
    font-weight: bold;
    margin-top: 22px;
    line-height: 18px;
}
.common_template .dialog .dialog_banner_register {
    background: url("/static/img/tankuang/register_free.png") no-repeat;
    background-size: 100% 100%;
}

.common_template .dialog .dialog_banner_min {
    background: url("/static/img/tankuang/minprog_free.png") no-repeat;
    background-size: 100% 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog.vue